export const getRussianPluralForm = (count: number, titles: string[]) => {
  const cases = [2, 0, 1, 1, 1, 2];

  if (count % 100 > 4 && count % 100 < 20) {
    return `${count} ${titles[2]}`;
  }

  const caseIndex = cases[Math.min(count % 10, 5)];

  return `${count} ${titles[caseIndex]}`;
};
